<template>
  <div class="ProperSection">
    <transition
        name="section"
    >
      <section
          v-if="visible"
          :class="{ 'active-section': active, 'chosen': chosen }"
          :style="{ '--content-height': contentHeight }"
          class="section"
          @click="$emit('click')">
        <div class="content">
          <header>
            <p class="font-size-big">
              {{ title }}
              <span v-if="subtitle && active" class="subtitle font-size-middle">{{ subtitle }}</span>
            </p>
            <div v-if="hasIcon">
              <img v-if="hasIcon" :src="require('@/assets/images/' + source)">
            </div>
          </header>
          <div class="fields">
            <slot></slot>
          </div>
        </div>
        <div class="chosen-overlay">
          <div class="check-mark">
            <font-awesome-icon icon="check"/>
          </div>
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ProperSection',

  props: {
    contentHeight: {
      type: String,
      default: '75px',
    },
    visible: {
      type: Boolean,
      default: true,
    },
    chosen: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: null,
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.android-content .section #tokenizeButton {
  border: none!important;
  background: $gold;
  border-radius: 22.5px;
  color: #000;
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.android-content .section {
  border: none;
  padding: 0;
}

.section {
  // Mobile style
  @media (max-width: $phone-max-width) {
    padding: 10px 10px;
  }

  position: relative;
  //display: block;
  display: flex;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 30px;
  padding: 20px 30px;
  padding-right: 20px;
  max-width: 500px;
  border: 1px solid #aaa;
  border-radius: 20px;

  overflow: hidden;
  height: 75px;
  transition: 0.2s ease-in-out height;

  &:not(.active-section) {
    header {
      p {
        .subtitle {
          opacity: 0;
        }
      }

      .image-placeholder {
        margin-top: -3px;
      }
    }

    .fields {
      display: none;
    }
  }

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
      margin: 0;
      color: #ddd;

      span {
        display: block;
        //font-size: 0.6em;
        color: white;
        margin-top: 10px;
      }
    }

    div {
      display: flex;
      width: 20%;

      img {
        width: 100%;
      }

    }

    // Mobile style
    @media (max-width: $phone-max-width) {
      div {
        width: 30%;
      }
    }

  }

  .fields {
    .field-row {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      * {
        flex: 1 1;
        margin-bottom: 0;
      }

      .date-picker {
        flex: 0 0 auto;
        display: flex;
        align-items: flex-end;
        height: 40px;
        margin-right: 30px;

        .field {
          flex: 0 0 auto;
          width: 2.8em;
        }

        .slash {
          position: relative;
          bottom: 10px;
          flex: 0 0 auto;
          margin: 0 10px;
        }
      }
    }
  }

  .content {
    opacity: 1;
    transition: 0.5s ease-in-out opacity;
    max-width: 100%;
  }

  .chosen-overlay {
    pointer-events: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: 0.5s ease-in-out opacity;
    transition-delay: 0.5s;

    .check-mark {
      display: block;
      font-size: 4em;
      color: $primary;
    }
  }

  &.chosen {
    .content {
      opacity: 0;
    }

    .chosen-overlay {
      opacity: 1;
    }
  }
}

.active-section {
  border-color: $primary;
  border-radius: 20px;
  height: 256px;
  display: flex;
  justify-content: center;
  align-items: center;

  header {
    p {
      color: $primary;
      margin-bottom: 20px;
      margin-right: 10px;

      .subtitle {
        margin-top: 15px;
      }
    }

    div {
        width: 30%;
        transition: width 0.3s ease;
    }

    // Mobile style
    @media (max-width: $phone-max-width) {
      div {
        width: 40%;
      }
    }
  }
}

// Enter/Leave section transitions
.section-leave-active {
  animation: section-out .5s;
}

@keyframes section-out {
  0% {
    overflow: hidden;
    opacity: 1;
  }

  100% {
    opacity: 0;
    height: 0;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
